<template lang="pug">
  div(:class="['widget', {'border-error': error}]")

    v-container
      v-layout(justify-space-between align-center)
        span(class="subheading") Lease information
        worth

      template(v-if="loading")
        v-layout(align-center justify-center fill-height)
          v-progress-circular(size="50" indeterminate)

      template(v-else)
        v-container(style="padding: 12px 24px 0 24px;")
          v-layout(justify-space-between align-center style="height: 36px;")
            span Lease start
            span(v-if="lease.start === null" class="grey--text") N/A
            v-tooltip(v-else left)
              span(slot="activator") {{ lease.start | formatFn }}
              span {{ lease.start | formatLLL }}
          v-divider
          v-layout(justify-space-between align-center style="height: 36px;")
            span Lease expiry
            span(v-if="lease.expiry === null" class="grey--text") N/A
            v-tooltip(v-else left)
              span(slot="activator") {{ lease.expiry | formatFn }}
              span {{ lease.expiry | formatLLL }}
          v-divider
          v-layout(justify-space-between align-center style="height: 36px;")
            span Initial term
            span(v-if="lease.term === null" class="grey--text") N/A
            span(v-else) {{ lease.term }} months
          v-divider
          v-layout(justify-space-between align-center style="height: 36px;")
            span Annual rent
            span ${{ (new Number(lease.rent)).toLocaleString() }}

</template>

<script>
import Worth from "./Worth.vue";

export default {
  name: "lease",
  components: { Worth },
  data () {
    return {
      error: false,
      lease: {},
      loading: false
    };
  },
  created () {
    this.loading = true;
    this.$http.
      get(`/api/sites/${this.$route.params.id}/lease`).
      then((r) => this.lease = r.data).
      catch(() => this.error = true).
      finally(() => this.loading = false);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Site/Lease.vue